import { Divider as DividerMui, DividerProps } from '@mui/material';

export const Divider: React.FC<DividerProps> = props => {
  const { className } = props;
  return (
    <div className={className}>
      <DividerMui light {...props} />
    </div>
  );
};
